module.exports = __webpack_public_path__ + "static/media/hcsb.7fd31820.jpg";